
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.197 10.94l-1.059 1.062 2.125 2.118 1.06-1.062-2.126-2.118zm12.094-7.881A1.5 1.5 0 0016.166.94l2.125 2.118zm-9.969 9.999l9.969-10L16.166.942 6.197 10.94l2.125 2.118z"}}),_c('path',{attrs:{"d":"M6.2 13.06l1.06 1.061L9.38 12l-1.06-1.06-2.122 2.12zM3.06 5.68A1.5 1.5 0 00.94 7.8L3.06 5.68zm5.26 5.26L3.06 5.68.94 7.8l5.26 5.26 2.12-2.122z"}})])
          )
        }
      }
    